<template>
    <div class="page-content">
      <div class="tle-row part">
        <div class="tle-col one-third">
          <table-surface-loyer/>
        </div>
          <div class="tle-col two-third">
            <div class="tle-row">
              <div class="tle-col">
                <p class="label main_color_text">
                Caractéristiques des logements
              </p>
              <div class="tle-row">
                <div class="tle-col one-third pd-tiny-right">
                <el-closed-question
                  :parent_data="
                    active_study.etudeData.gie.sectionCaracteristiquesResidence
                  "
                  property="menuiserie"
                  :editable="true"
                  label="Menuiserie"
                  :options="['Bois', 'Aluminium', 'PVC', 'NC']"
                  :dense="true"
                />
                </div>
                <div class="tle-col one-third pd-tiny-left pd-tiny-right">
                  <el-closed-question
                    :parent_data="
                      active_study.etudeData.gie.sectionCaracteristiquesResidence
                    "
                    property="cave"
                    :editable="true"
                    label="Cave"
                    :allowNC="true"
                    :dense="true"
                  />
                </div>
                <div class="tle-col one-third pd-tiny-left">
                  <el-closed-question
                    :parent_data="
                      active_study.etudeData.gie.sectionCaracteristiquesResidence
                    "
                    property="parking"
                    :editable="true"
                    label="parking"
                    :options="['Aucun', 'Extérieur', 'Couvert', 'Intérieur', 'Box', 'NC']"
                    :dense="true"
                  />
                </div>
              </div>
              <el-closed-question
                :parent_data="
                  active_study.etudeData.gie.sectionCaracteristiquesResidence
                "
                property="taille_surface_habitable"
                :editable="true"
                label="Taille des surfaces habitables"
                :options="['Compactes', 'Standard', 'Spacieuses', 'NC']"
                :dense="true"
              />
              <el-closed-question
                :parent_data="
                  active_study.etudeData.gie.sectionCaracteristiquesResidence
                "
                property="taille_surface_exterieure"
                :editable="true"
                label="Taille des surfaces extérieures"
                :options="['Compactes', 'Standard', 'Spacieuses', 'NC']"
                :dense="true"
              />
              <div class="tle-row">
                <div class="tle-col half pd-tiny-right">
                  <el-closed-question
                    :parent_data="
                    active_study.etudeData.gie.sectionCaracteristiquesResidence
                    "
                    property="mode_chauffage"
                    :editable="true"
                    label="Mode de chauffage"
                    :options="['Individuel', 'Collectif', 'NC']"
                    :dense="true"
                  />
                </div>
                <div class="tle-col half pd-tiny-left">
                    <el-closed-question
                      :parent_data="
                        active_study.etudeData.gie.sectionCaracteristiquesResidence
                      "
                      property="energie_utilise"
                      :editable="true"
                      label="Energie utilisée"
                      :options="['Gaz', 'Électrique', 'Autre', 'NC']"
                      :dense="true"
                    />
                </div>
              </div>
              
            </div>
          </div>
        </div>
          <p class="label main_color_text">Caractéristiques de la résidence</p>
            <div class="tle-row" style="width: 100%; margin-left: auto; margin-right: auto;">
                
                  <div class="tle-col two-fifth pd-tiny-right">
                    <div
                      class="el-closed-question dense"
                      :class="{ 'can-change': editor.mode == 'editing' }"
                    >
                      <div class="question-label">
                        <div>Epoque de construction</div>
                      </div>
                      <span class="question-value">
                        <el-textarea
                          :parent_data="
                            active_study.etudeData.gie.sectionCaracteristiquesResidence
                          "
                          property="epoque_construction"
                          :editable="true"
                        />
                      </span>
                    </div>
                  
                  
                    <el-closed-question
                      :parent_data="
                        active_study.etudeData.gie.sectionCaracteristiquesResidence
                      "
                      property="presence_gardien"
                      :editable="true"
                      label="Présence d’un gardien"
                      :allowNC="true"
                      :dense="true"
                    />
                  </div>
                  <div class="tle-col one-fifth pd-tiny-left pd-tiny-right" style="font-size:8px">
                    <el-closed-question
                      :parent_data="
                        active_study.etudeData.gie.sectionCaracteristiquesResidence
                      "
                      property="portail_securise"
                      :editable="true"
                      label="Portail sécurisé"
                      :allowNC="true"
                      :dense="true"
                    />
                    <el-closed-question
                      :parent_data="
                        active_study.etudeData.gie.sectionCaracteristiquesResidence
                      "
                      property="entree_securisee"
                      :editable="true"
                      label="Entrée sécurisée"
                      :allowNC="true"
                      :dense="true"
                    />
                  </div>
                  <div class="tle-col two-fifth pd-tiny-left">
                    <el-closed-question
                      :parent_data="
                        active_study.etudeData.gie.sectionCaracteristiquesResidence
                      "
                      property="etat_parties_communes_ext"
                      :editable="true"
                      label="État des parties communes extérieures"
                      :options="['Très bon', 'Bon', 'Moyen', 'Mauvais', 'NC']"
                      :dense="true"
                    />
                    <el-closed-question
                      :parent_data="
                        active_study.etudeData.gie.sectionCaracteristiquesResidence
                      "
                      property="etat_parties_communes_int"
                      :editable="true"
                      label="État des parties communes intérieures"
                      :options="['Très bon', 'Bon', 'Moyen', 'Mauvais', 'NC']"
                      :dense="true"
                    />
                  </div>
              </div>
      </div>
  </div>
</template>
    

<script>
import { mapGetters } from "vuex";

import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import getParameter from "@/libs/get_parameter.js";
import tableSurfaceLoyer from "@/components/study/editor/elements/data/table/table-surface-loyer";

export default {
	components: {
		tableSurfaceLoyer,
	},
	name: "section-caracteristique-standing-flash",
	mixins: [PageMixin],
	data: function () {
		return {
			form: {},
			themePromo: "dynamique_marche_residentiel_promotion"
		};
	},
	props: ["index"],
	computed: {
		...mapGetters([
			"active_study",
			"app_parameters",
			"editor",
			"etude_data"
		]),
		parameters () {
			return this.active_study.qlikData.parameters.editmode.find((editmode) => {
				return editmode.theme == this.themePromo;
			});
		},
		last_year_period () {
			return this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code);
		},
		last_year_periodTitle () {
      try{
        const currentPeriod = this.parameters.periods.values.find((value) => {
				  return value.code == this.last_year_period;
        });
        return currentPeriod.title;
      }catch(e){
        return "Marché de la promotion immobilière :";
      }
		},
	},
	methods: {
		getParameter (name, defaultValue) {
			return getParameter(this.etude_data, this.themePromo, name, defaultValue);
		}
	},

};

</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app';
@import '../../../../../assets/css/page';


.pd-tiny-left{
  padding-left: 2px;
}
.pd-tiny-right{
  padding-right: 2px;
}
</style>
